import React from "react";
import { Link as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";
import { AppBar, Box, Button, Toolbar, useMediaQuery, useTheme } from "@mui/material";
import Logo from "src/components/Logo";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(theme => ({
    toolbar: {
        height: 64,
    },
    logo: {
        marginRight: theme.spacing(2),
    },
    link: {
        fontWeight: theme.typography.fontWeightMedium,
        "& + &": {
            marginLeft: theme.spacing(2),
        },
    },
}));

const TopBar = ({ className, ...rest }) => {
    const { t } = useTranslation();
    const { classes, cx } = useStyles();
    const theme = useTheme();
    const smallMobileDevice = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <AppBar
            enableColorOnDark
            className={cx(classes.root, className)}
            style={{
                background: "transparent",
                boxShadow: "none",
                paddingTop: 32,
                paddingRight: 16,
                paddingLeft: 16,
                paddingBottom: 24,
            }}
            {...rest}
        >
            <Toolbar className={classes.toolbar}>
                <RouterLink to="/" style={{ textDecoration: "none" }}>
                    <Logo className={classes.logo} />
                </RouterLink>
                <Box flexGrow={1} />
                {!smallMobileDevice && (
                    <>
                        <Button
                            color="inherit"
                            component={RouterLink}
                            to="/products"
                            style={{ marginRight: 16 }}
                        >
                            {t("products")}
                        </Button>
                        <Button
                            color="inherit"
                            component={RouterLink}
                            to="/about"
                            style={{ marginRight: 16 }}
                        >
                            {t("about")}
                        </Button>
                        <Button
                            color="secondary"
                            variant="contained"
                            size="large"
                        >
                            {t("contact")}
                        </Button>
                    </>
                )}
            </Toolbar>
        </AppBar>
    );
};

TopBar.propTypes = {
    className: PropTypes.string,
};

export default TopBar;
